import { LitElement, css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'

import DATABASE_SVG from '../shared-assets/database.svg'

export type EPDatabaseButtonVariant = 'default' | 'icon-only' | 'text-only'

@customElement('ep-database-button')
export class EPDatabaseButton extends LitElement {

  @property({ reflect: true })
  variant: EPDatabaseButtonVariant = 'default'

  @property({ type: Boolean, reflect: true })
  disabled: boolean = false;

  renderContent() {
    switch (this.variant) {
      case 'default': return html`
        <img slot="start" src=${DATABASE_SVG} style="width: 20px;" />
        <slot></slot>
      `;
      case 'icon-only': return html`
        <img src=${DATABASE_SVG} style="width: 20px;" />
      `;
      case 'text-only': return html`
        <slot></slot>
      `;
    }
  }

  render() {   
    return html`
      <ep-fluent-button appearance="accent" accent-color="#3e1f62" ?disabled=${this.disabled}>
        ${this.renderContent()}
      </ep-fluent-button>
    `
  }

  static styles = css`
    :host {
      display: contents;
      --og: #5c2d91;
      --temp: #3e1f62;
    }


  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-database-button': EPDatabaseButton
  }
}
